import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiParameter,
    doesNotHaveExpand,
    HasPagingParameters,
    patch,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";

export interface GetOrdersApiParameter extends ApiParameter, HasPagingParameters {
    orderNumber?: string;
    poNumber?: string;
    search?: string;
    status?: string[];
    customerSequence?: string;
    fromDate?: string;
    toDate?: string;
    orderTotalOperator?: string;
    orderTotal?: number;
    productErpNumber?: string;
    sort?: string;
    displayName?: string;
    vmiOrdersOnly?: boolean;
    vmiLocationId?: string;
    vmiBinId?: string;
    expand?: ("orderLines" | "vmidetails")[];
}

export interface GetOrderApiParameter extends ApiParameter {
    orderNumber: string;
    expand?: ("orderLines" | "shipments" | "vmidetails")[];
    additionalExpands?: string[];
    sTEmail?: string;
    sTPostalCode?: string;
}

export interface GetOrderStatusMappingsApiParameter extends ApiParameter { }

export interface UpdateOrderApiParameter extends ApiParameter {
    order: OrderModel;
}

const ordersUrl = "/api/v1/orders";

export async function updateOrder(parameter: UpdateOrderApiParameter): Promise<ServiceResult<OrderModel>> {
    try {
        const order = parameter.order;
        const orderNumber = order.erpOrderNumber || order.webOrderNumber;
        const orderModel = await patch<OrderModel>(`${ordersUrl}/${orderNumber}`, order);
        cleanOrder(orderModel);
        return {
            successful: true,
            result: orderModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

function cleanOrder(orderModel: OrderModel, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
    orderModel.orderDate = new Date(orderModel.orderDate);
    orderModel.id = orderModel.erpOrderNumber || orderModel.webOrderNumber;
    if (doesNotHaveExpand(parameter, "orderLines")) {
        delete orderModel.orderLines;
    }

    if (!orderModel.shipViaDescription) {
        delete orderModel.shipViaDescription;
    }
}
